import React, { useState } from "react";
import ExpectedBehaviour from "./expectedBehaviour/expected-behaviour";
import BedroomAndHome from "./bedroomAndHome/bedroom-and-home";
import Activities from "./activities/activities";
import Meals from "./meals/meals";
import Visitors from "./visitors/visitors";
import AnyOtherRules from "./anuOtherRules/any-other-rules";
import Education from "./education/education";

const HouseRulesAdmission = () => {
  const [currentStep, setCurrentStep] = useState(0); // Step index
  const [formData, setFormData] = useState({
    rulesInfo: {},
  });

  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  // Update data for each form
  const updateFormData = (newData) => {
    setFormData((prevState) => ({
      ...prevState,
      ...newData,
    }));
  };

  console.log("formData", formData);

  const handleSubmit = () => {
    console.log("Final Form Data:", formData);
  };

  // Rendering forms based on step
  const renderForm = () => {
    switch (currentStep) {
      case 0:
        return <ExpectedBehaviour nextStep={nextStep} />;
      case 1:
        return <BedroomAndHome nextStep={nextStep} prevStep={prevStep} />;
      case 2:
        return <Activities nextStep={nextStep} prevStep={prevStep} />;
      case 3:
        return <Education nextStep={nextStep} prevStep={prevStep} />;
      case 4:
        return <Meals nextStep={nextStep} prevStep={prevStep} />;
      case 5:
        return <Visitors nextStep={nextStep} prevStep={prevStep} />;
      case 6:
        return <AnyOtherRules updateFormData={updateFormData} prevStep={prevStep} handleSubmit={handleSubmit} />;
      default:
        return null;
    }
  };

  return <div>{renderForm()}</div>;
};

export default HouseRulesAdmission;
